module.exports = __webpack_public_path__ + "static/media/lateral-flexion-up-1.a3cd3d80.png";